/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

class GslbServiceWrapperPageControlller {
    $onDestroy() {
        this.gslb_.destroy();
    }
}

/**
 * @ngdoc component
 * @name  gslbServiceWrapperPage
 * @param {GSLB} gslb_ - GSLB instance, only included here to destroy as needed.
 * @author alextsg
 * @description
 *     Wrapper component for all GslbService components/pages. Written in AngularJS since child
 *     components are still written in AngularJS.
 */
angular.module('avi/gslb').component('gslbServiceWrapperPage', {
    bindings: {
        gslb_: '<resolveGslb',
    },
    controller: GslbServiceWrapperPageControlller,
    template: '<ui-view></ui-view>',
});
